<template>
	<VerticalLayout>
		<span>{{ $t(labelKey) }}</span>
		<Select
			class="width-100"
			v-model:value="gnssSelected"
			mode="multiple"
			:filterOption="filterGnssOption"
			:allowClear="true"
			:options="gnssOptions"
			@change="onChange"
		/>
	</VerticalLayout>
</template>

<script>
import { Select } from 'ant-design-vue';

import VerticalLayout from '@/components/common/VerticalLayout';

import { useGnssOptions } from '@/components/stats/useGnssOptions';

export default {
	components: { VerticalLayout, Select },
	props: {
		onChange: {
			type: Function,
			required: false,
			default: () => {},
		},
		labelKey: {
			type: String,
			default: 'controls.gnssSelect.label',
		},
		codes: {
			type: Array,
			required: false,
			default: null,
		},
		defaultSelected: {
			type: Array,
			required: false,
			default: null,
		},
	},
	setup(props, { expose }) {
		const codesValue = props.codes != null ? props.codes : undefined;
		const { gnssOptions, gnssSelected, filterGnssOption } = useGnssOptions(
			true,
			false,
			codesValue,
			props.defaultSelected,
		);
		expose({
			selected: gnssSelected,
			options: gnssOptions,
		});
		return {
			gnssSelected,
			gnssOptions,
			filterGnssOption,
		};
	},
}
</script>
